// @flow
import type { ChannelUFC } from "@tvg/types/Alerts";
import type { SetRaceAlertsActionType } from "@tvg/shared-actions/UserActions";

export type State = {
  raceAlerts: ChannelUFC[],
  userId?: string
};

export const initialState = {
  raceAlerts: [],
  userId: ""
};

export default function alertsReducer(
  state: State = initialState,
  action: SetRaceAlertsActionType
) {
  switch (action.type) {
    case "SET_RACE_ALERTS": {
      return { ...state, raceAlerts: action.payload.channels };
    }

    case "SET_RACE_ALERTS_USER_ID": {
      if (!state.userId) return { ...state, userId: action.payload };

      if (action.payload !== state.userId) {
        return { ...state, raceAlerts: [], userId: action.payload };
      }
      return { ...state, userId: action.payload };
    }

    default: {
      return state;
    }
  }
}
